export enum ApplicationsLabel {
  AUTOMATIONCENTRE = 'Automation Centre',
  SCRIPTLIBRARY = 'Script Library',
}
